import { Controller } from 'stimulus';

class DeliveryAndPayment extends Controller {
  connect() {
    this.onPaymentMethodChange();
  }

  formHasErrors() {
    return $(this.formTarget).find('.porta-error').length > 0;
  }

  onPaymentMethodChange() {
    this.disableSubmit(false);

    const $selectedMethod = $(this.paymentMethodTargets).filter(':checked');

    const isDirectDebit = $selectedMethod.data('identifier') === 'direct-debit';
    const isAfterpay = $selectedMethod.data('identifier') === 'afterpay';

    if (this.hasDirectDebitWrapper) {
      $(this.directDebitWrapperTarget).toggle(isDirectDebit);
      $(this.directDebitWrapperTarget).find('input').prop('required', isDirectDebit);
    }

    $(this.afterpayAgreementWrapperTarget).toggle(isAfterpay);
    $(this.afterpayAgreementWrapperTarget)
      .find('input')
      .val(isAfterpay ? 1 : 0)
      .prop('required', isAfterpay);
  }

  onAfterpayAgreementChange(e) {
    if ($(e.currentTarget).hasClass('porta-error') && !e.currentTarget.checked) {
      this.disableSubmit(true);

      return;
    }

    $(e.currentTarget)
      .removeClass('porta-error')
      .parent()
      .find('.porta-error-message')
      .remove();

    this.disableSubmit(false);
  }

  onSubmit(e) {
    if (this.formHasErrors()) {
      e.preventDefault();
    }

    this.disableSubmit(true);
  }

  disableSubmit(state) {
    $(this.submitTarget).prop('disabled', state);
  }
}

DeliveryAndPayment.targets = [
  'form',
  'submit',
  'paymentMethod',
  'directDebitWrapper',
  'afterpayAgreementWrapper',
];

export default DeliveryAndPayment;
